// frontend/src/services/activityService.js
import api from './api';

/**
 * Sends a log to the backend indicating a user has viewed a page.
 * @param {string} pagePath - The path of the page viewed (e.g., '/students').
 */
export const logPageView = async (pagePath) => {
    try {
        // We don't need to wait for a response or handle errors here,
        // as this is a "fire-and-forget" action. If it fails, it's not critical.
        api.post('/activity/log-page-view', { page: pagePath });
    } catch (error) {
        // Silently log the error to the console for debugging, but don't bother the user.
        console.error("Failed to log page view:", error);
    }
};